import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-045d83be")

_pushScopeId("data-v-045d83be")
const _hoisted_1 = { class: "main-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SessionCountDownModal = _resolveComponent("SessionCountDownModal")
  const _component_SessionExpiredModal = _resolveComponent("SessionExpiredModal")
  const _component_HeaderMain = _resolveComponent("HeaderMain")
  const _component_SidebarMain = _resolveComponent("SidebarMain")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.showSessionCountdownModal)
      ? (_openBlock(), _createBlock(_component_SessionCountDownModal, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.showSessionExpiredModal)
      ? (_openBlock(), _createBlock(_component_SessionExpiredModal, { key: 1 }))
      : _createCommentVNode("", true),
    (!_ctx.noWrapperRoutes.includes(_ctx.$route.name))
      ? (_openBlock(), _createBlock("div", {
          key: 2,
          class: ["page-wrapper", {'white-top': _ctx.$route.name === 'dashboard'}]
        }, [
          _createVNode(_component_HeaderMain),
          _createVNode(_component_SidebarMain),
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_router_view)
          ])
        ], 2))
      : (_openBlock(), _createBlock(_component_router_view, { key: 3 }))
  ], 64))
})